export default __webpack_public_path__ + "e556fb5feb8adae60e7963f438c73bd6.png";